import React from 'react'
import Notiflix from 'notiflix';
import AppRoutes from './AppRoutes';
import "./helper/interceptor";
import "./App.css";
Notiflix.Notify.init({
  showOnlyTheLastOne: true,
  timeout: 3000,
  clickToClose: true,
  pauseOnHover: true,
});

function App() {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;
